import React from "react";
import { toast } from "react-hot-toast";
import CopyIcon from "../icons/CopyIcon";
import { useRouter } from "next/router";
export const copyToClipboard = (value, locale) => {
    navigator.clipboard
      .writeText(value)
      .then(() => {
        toast.success(
          `${value} ${
            locale === "ar" ? "تم نسخه" : "copied successfully"
          }`
        );
      })
      .catch((err) => {
        console.log("err", err);
        toast.error(locale === "ar" ? "فشلت عملية النسخ" : "Failed to copy");
      });
  };
const Clipboard = ({ value }) => {
  const { locale } = useRouter();

  return <CopyIcon onClick={() => copyToClipboard(value, locale)} className="w-" />;
};

export default Clipboard;
